/* eslint-disable @typescript-eslint/await-thenable */
import { useAppDispatch, useAppSelector } from 'store/hooks';
import React from 'react';
import { Box } from '@mui/material';
import { AudienceCreateRequestData, createAudience } from 'store/audiences/audiencesSlice';
import { MuiModal } from 'ui/MuiModal';
import { AudienceCreateForm, AudienceCreateFormData } from '../forms/AudienceCreateForm';
import { Audience, AudienceType, isAudience } from '../models/segmentModel';
import { getTimeUnitsToSeconds } from 'lib/timeHelpers';

interface AudienceCreateModalProps {
    open: boolean;
    onClose: () => void;
    initialData?: Partial<AudienceCreateFormData>;
    onSuccess?: (audience: Audience) => void;
}

const AudienceCreateModalContent: React.FC<AudienceCreateModalProps> = ({
    onSuccess,
    initialData,
    onClose
}) => {
    const { isLoading } = useAppSelector(state => state.audiences);
    const dispatch = useAppDispatch();
    const handleSubmit = React.useCallback(
        async ({ expires, measure, ...rest }: AudienceCreateFormData) => {
            const createBody: AudienceCreateRequestData = {
                ...rest
            };
            if (rest.type !== AudienceType.PERSISTENT) {
                createBody.expiryHorizon = getTimeUnitsToSeconds(Number(expires), measure);
            }
            const audience = await dispatch(createAudience(createBody));
            if (!!audience && isAudience(audience) && !!onSuccess) {
                onSuccess(audience);
            }
        },
        [dispatch, onSuccess]
    );
    return (
        <Box width={60 * 8}>
            <AudienceCreateForm
                initialData={initialData}
                onSubmit={handleSubmit}
                isLoading={isLoading}
                onClose={onClose}
            />
        </Box>
    );
};

export const AudienceCreateModal = (props: AudienceCreateModalProps) => (
    <MuiModal open={props.open} onClose={props.onClose}>
        <AudienceCreateModalContent {...props} />
    </MuiModal>
);
